import * as ivsServices from '@/services/ivsServices';
import * as userServices from '@/services/userServices';

export default {
  async createChannel({ commit }, userId) {
    const { channel, streamKey } = await ivsServices.createIvsChannel(userId);
    await userServices.updateUserDoc(userId, {
      ivsChannelArn: channel.arn,
      ivsStreamKeyArn: streamKey.arn
    });

    commit('ivs/initStore', {
      channel: channel,
      streamKey: streamKey
    });
    commit('user/updateIvsChannelArn', channel.arn);
    commit('user/updateIvsStreamKeyArn', streamKey.arn);
  }
};
